<stable aria-label="Domain Details" role="table" [sTableOptions]="allDomainTableOptions" (actionCallback)="actionCall($event)"></stable>